import React from "react";
import {
  Box,
  Chip,
  Paper,
  Switch,
  Typography,
  FormControlLabel,
  Tooltip,
  IconButton,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  sectionCard: {
    borderRadius: 14,
    border: "1px solid #edf0f5",
    boxShadow: "0 10px 24px rgba(15, 23, 42, 0.045)",
    padding: theme.spacing(3),
    background: "#fff",
    width: "100%",
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(2),
    },
  },
  sectionHeader: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  title: {
    fontWeight: 700,
    color: "#20222a",
    letterSpacing: 0,
  },
  description: {
    color: "#64748b",
    fontSize: 13,
    marginTop: 4,
  },
  badge: {
    height: 24,
    fontWeight: 700,
    borderRadius: 999,
    "& .MuiChip-label": {
      paddingLeft: 10,
      paddingRight: 10,
    },
  },
  fieldSwitch: {
    margin: 0,
    width: "100%",
    border: "1px solid rgba(15, 23, 42, 0.08)",
    borderRadius: 12,
    padding: theme.spacing(1, 1.25),
    justifyContent: "space-between",
    background: "#f8fafc",
  },
  fieldSwitchLabel: {
    color: "#334155",
    fontWeight: 600,
    fontSize: 14,
  },
  iconButton: {
    border: "1px solid rgba(15, 23, 42, 0.1)",
    background: "#fff",
    "&:hover": {
      background: "#f8fafc",
    },
  },
}));

export function SectionCard({ title, description, action, children, style }) {
  const classes = useStyles();

  return (
    <Paper elevation={0} className={classes.sectionCard} style={style}>
      {(title || description || action) && (
        <Box className={classes.sectionHeader}>
          <Box>
            {title && (
              <Typography variant="h6" className={classes.title}>
                {title}
              </Typography>
            )}
            {description && (
              <Typography className={classes.description}>
                {description}
              </Typography>
            )}
          </Box>
          {action}
        </Box>
      )}
      {children}
    </Paper>
  );
}

export function StatusBadge({ active, label, trueLabel = "Ativo", falseLabel = "Inativo" }) {
  const classes = useStyles();
  const isActive = active === true || active === "enabled" || active === "Sim";

  return (
    <Chip
      size="small"
      className={classes.badge}
      label={label || (isActive ? trueLabel : falseLabel)}
      style={{
        color: isActive ? "#047857" : "#b91c1c",
        backgroundColor: isActive ? "#dcfce7" : "#fee2e2",
      }}
    />
  );
}

export function PlanBadge({ children }) {
  const classes = useStyles();
  return (
    <Chip
      size="small"
      className={classes.badge}
      label={children || "-"}
      style={{
        color: "#1d4ed8",
        backgroundColor: "#dbeafe",
      }}
    />
  );
}

export function BooleanBadge({ value }) {
  return (
    <StatusBadge
      active={value}
      trueLabel="Sim"
      falseLabel="Não"
      label={value === false ? "Não" : "Sim"}
    />
  );
}

export function SettingSwitch({ label, checked, onChange, disabled }) {
  const classes = useStyles();

  return (
    <FormControlLabel
      className={classes.fieldSwitch}
      classes={{ label: classes.fieldSwitchLabel }}
      label={label}
      labelPlacement="start"
      control={
        <Switch
          color="primary"
          checked={Boolean(checked)}
          onChange={(event) => onChange(event.target.checked)}
          disabled={disabled}
        />
      }
    />
  );
}

export function ActionIconButton({ title, children, onClick, disabled }) {
  const classes = useStyles();

  return (
    <Tooltip title={title || ""}>
      <span>
        <IconButton
          size="small"
          onClick={onClick}
          disabled={disabled}
          className={classes.iconButton}
        >
          {children}
        </IconButton>
      </span>
    </Tooltip>
  );
}
